var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6109 43.4188L3.125 48.4375V32.0313L8.55938 29.5938C8.99688 29.3969 9.50781 29.6391 9.63281 30.1032L12.9984 42.525C13.0953 42.8766 12.9328 43.2485 12.6109 43.4188Z",
    fill: "#157B7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0529 32.3485L31.0873 39.3688C29.6592 40.1422 27.9857 40.3297 26.4232 39.8907L19.517 37.9532L14.8107 40.2485L12.0342 29.9954L16.6545 27.6985C18.1232 26.9641 19.742 26.5813 21.3842 26.5813H31.042C34.0764 26.5813 34.2451 31.1047 31.242 31.3469L27.6389 31.6422C26.0764 31.7704 26.2857 34.1094 27.8311 33.9813L31.4311 33.6829C33.4404 33.5204 35.0701 32.0735 35.5857 30.2016L42.542 28.2891C45.0889 27.5922 46.4279 31.2157 44.0529 32.3485Z",
    fill: "#157B7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 15.625V21.0938C40.625 22.3875 39.575 23.4375 38.2812 23.4375H21.0938C19.8 23.4375 18.75 22.3875 18.75 21.0938V15.625H40.625Z",
    fill: "#AD186A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 7.8125H34.375V5.07812C34.375 4 33.5 3.125 32.4219 3.125H26.9531C25.875 3.125 25 4 25 5.07812V7.8125H21.0938C19.8 7.8125 18.75 8.8625 18.75 10.1562V13.2812H40.625V10.1562C40.625 8.8625 39.575 7.8125 38.2812 7.8125ZM27.3438 5.46875H32.0312V7.8125H27.3438V5.46875Z",
    fill: "#AD186A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobOffer);
export default __webpack_public_path__ + "static/media/job_offer.d64e1d92d948551fd1733bfd0084346d.svg";
export { ForwardRef as ReactComponent };